import TableCell from '@mui/material/TableCell';
import { ITableHeadCell } from 'components/@shared/TableRemotePagination/types';
import { InvoiceResponseViewModel } from 'types/invoice';

import { InvoiceListCell } from './InvoiceListCell';

interface Props {
    columns: ITableHeadCell[];
    rowData: InvoiceResponseViewModel;
}

export const InvoiceListRow = ({ columns, rowData }: Props) => (
    <>
        {columns.map((item) => (
            <TableCell id={item.id} key={item.field}>
                <InvoiceListCell {...{ item, rowData }} />
            </TableCell>
        ))}
    </>
);
